import 'vanilla-cookieconsent/dist/cookieconsent.css'
import * as CookieConsent from 'vanilla-cookieconsent'
import { PostHogOptIn, PostHogOptOut } from './posthog'
import { sentryClose, sentryInit } from './Sentry'

export function runCookieConsent(): void {
  CookieConsent.run({
    categories: {
      necessary: {
        enabled: true, // this category is enabled by default
        readOnly: true, // this category cannot be disabled
      },
      analytics: {
        enabled: false,
      },
    },

    language: {
      default: 'sv',
      translations: {
        sv: {
          consentModal: {
            title: 'Vi värnar om din integritet',
            description: `Vi använder teknologier som cookies och analysverktyg för att förbättra din upplevelse, analysera webbplatstrafik och utveckla våra tjänster. 
            Dessa verktyg hjälper oss att förstå hur vår webbplats används och göra den bättre för dig.<br/>
            Du kan välja att godkänna eller hantera dessa teknologier genom att klicka på "Hantera inställningar" eller "Acceptera alla" för att ge ditt samtycke. För mer information, vänligen läs vår <a href='/privacy-policy' target='_blank'>Integritetspolicy</a>.`,
            acceptAllBtn: 'Acceptera alla',
            showPreferencesBtn: 'Hantera inställningar',
          },
          preferencesModal: {
            title: 'Inställningar',
            acceptAllBtn: 'Acceptera alla',
            savePreferencesBtn: 'Acceptera aktuellt val',
            closeIconLabel: 'Stäng modal',
            sections: [
              {
                description: `Vissa cookies är absolut nödvändiga för att webbplatsen ska fungera korrekt, och därför kan ändamålet 'Nödvändiga cookies, tekniker och funktioner' inte väljas bort. 
                För övriga ändamål kan du själv välja vilka du vill godkänna eller neka nedan.`,
              },
              {
                title: 'Nödvändiga cookies, tekniker och funktioner',
                description:
                  'Kakor och liknande tekniker som gör att webbsidan/appen fungerar säkert och korrekt. Webbsidan kan inte fungera ordentligt utan dessa. Exempel på nödvändiga kakor/tekniker är sådana som används för att utföra åtgärder som du har begärt, exempelvis inställning av dina personliga preferenser, inloggning eller när du ska fylla i ett formulär.',
                //this field will generate a toggle linked to the 'necessary' category
                linkedCategory: 'necessary',
              },
              {
                title: 'Kakor för analys och utveckling',
                description: `Kakor och tekniker som används för att ta fram statistik över besök på webbsidan/appen och information om hur webbsidan/appen används. 
                  Med hjälp av denna information kan vi optimera navigering och innehåll, utveckla våra tjänster och förbättra upplevelsen för dig som användare. 
                  Om du godkänner denna typ av kakor kommer vi även att behandla personuppgifter som samlas in med hjälp av dessa kakor. Denna behandling sker med vårt berättigade intresse som laglig grund.`,
                cookieTable: {
                  headers: { col1: 'Verktyg', col2: 'Syfte' },
                  body: [
                    {
                      col1: 'PostHog',
                      col2: 'Hjälper oss att analysera användarbeteenden och förbättra webbplatsen, samtidigt som vi skyddar din integritet.',
                    },
                    {
                      col1: 'Sentry.io',
                      col2: 'Används för att identifiera och spåra fel på vår webbplats, vilket hjälper oss att snabbt åtgärda problem och förbättra din användarupplevelse.',
                    },
                  ],
                },
                linkedCategory: 'analytics',
              },
            ],
          },
        },
      },
    },

    onConsent: ({ cookie }) => {
      if (cookie.categories.includes('analytics')) {
        PostHogOptIn()
        sentryInit()
      }
    },

    onChange: ({ cookie }) => {
      if (cookie.categories.includes('analytics')) {
        PostHogOptIn()
        sentryInit()
      } else {
        PostHogOptOut()
        sentryClose()
      }
    },

    guiOptions: {
      consentModal: {
        layout: 'bar',
      },
    },
    revision: 1,
    cookie: {
      name: process.env.REACT_APP_SVALNA_COOKIE_NAME,
      domain: process.env.REACT_APP_DOMAIN,
    },
  })
}

export function hideCookieConsent(): void {
  CookieConsent.hide()
}
